import BaseComponent from 'foundation/base-component';
import ComponentsFactory from 'foundation/components-factory';
import UrlHelper from 'foundation/url-helper';
import HtmlHelper from 'foundation/html-helper';
import api, { isHtmlContentType } from 'general/js/api';
import historyController from 'general/js/history-controller';
import pageSpinner from 'general/js/page-spinner';
import gtm from 'general/js/gtm';
import { reloadPage } from '../../../general/js/utils';

const SPA_LOAD_ID = 'spa-load';

class SpaLoad extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.historyChangeSubscribers = [];
        this.unregisterHistoryController = null;

        this.init();
    }

    init() {
        this.unregisterHistoryController = historyController.register(SPA_LOAD_ID, this.onHistoryChange);
    }

    destroy() {
        if (typeof this.unregisterHistoryController === 'function') {
            this.unregisterHistroyController();
        }
    }

    onHistoryChange = (prevState, newState, shouldClean) => {
        if (shouldClean && newState === null) {
            reloadPage();
            return;
        }

        this.renderPageHtml();
        this.notifyHistoryChangeSubscribers();
    };

    updateContent(url) {
        historyController.pushState(SPA_LOAD_ID, '', url);
        this.renderPageHtml();
    }

    renderPageHtml() {
        const url = UrlHelper.getOverlayUrl(window.location.pathname);
        const main = document.querySelector('#randa-main');

        if (!main) return;

        ComponentsFactory.getInstance().destroy(main);

        this.getPageHtml(url).then((html) => {
            try {
                main.innerHTML = html;
                ComponentsFactory.getInstance().init(main);
                this.handlePageChange(html);
            } catch (error) {
                return Promise.reject(error);
            }
        });
    }

    handlePageChange(html) {
        const name = HtmlHelper.getTitleFromPopupHtml(html);
        document.title = name;
        gtm.sendCurrentLocationAsVirtualUrl(HtmlHelper.getTitleFromPopupHtml(html));

    }

    notifyHistoryChangeSubscribers() {
        this.historyChangeSubscribers.forEach((subscriberCallback) => subscriberCallback());
    }

    subscribeOnHistoryChange(cb) {
        this.historyChangeSubscribers.push(cb);

        // return unsubscribe method
        return () => {
            this.historyChangeSubscribers = this.historyChangeSubscribers.filter((storedCb) => storedCb !== cb);
        };
    }

    getPageHtml(url) {
        if (!url) return Promise.reject();

        pageSpinner.show();

        return api.get(url)
            .then((response) => {
                if (isHtmlContentType(response)) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(new Error('Unknown result from async data'));
            }).then((result) => {
                pageSpinner.hide();
                return result;
            }, (error) => {
                pageSpinner.hide();
                return Promise.reject(error);
            });
    }
}

export default new SpaLoad();
